module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"accessBlocked":"Access blocked","invitation":"To open the site, <br> use our extension","download":"Download"},"ru":{"accessBlocked":"Доступ заблокирован","invitation":"Для обхода блокировки, <br> воспользуйтесь нашим расширением","download":"Скачать"}}')
  delete Component.options._Ctor
}
